module.exports = __webpack_public_path__ + "fontawesome-webfont.dfb02f8f6d0cedc009ee.woff";


//////////////////
// WEBPACK FOOTER
// /Users/thiago/Documents/projetos/biblioteco-angular/src/assets/global/plugins/font-awesome/fonts/fontawesome-webfont.woff?v=4.4.0
// module id = ../../../../../src/assets/global/plugins/font-awesome/fonts/fontawesome-webfont.woff?v=4.4.0
// module chunks = styles